import http from '../jslibs/axios/http'

// 获取演示/商务列表
export const getFormRecord = data => http.get('/v1/cms/FormRecord', data)

// 编辑获取演示/商务
export const editFormRecord = (uuid, data) => http.put(`/v1/cms/FormRecord/${uuid}`, data)

// 删除演示/商务
export const deleteFormRecord = uuid => http.delete(`/v1/cms/FormRecord/${uuid}`)

// 导出excel
export const formRecordExcel = data => http.get('/v1/cms/FormRecordExcel', data)
